import peopleLocale from './en.json'

const en = {
  people: peopleLocale,
}

export default en
